var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart"},[_c('BarChart',{attrs:{"data":_vm.dataChart,"x-name":"Respuestas","y-name":"Cantidad","label-rotate":"","rainbow":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }